import React from "react";

export const Pies3 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <g>
      <rect width={28} height={28} rx={1} fill="#F1F2F6" />
      <path
        fill="#DFA543"
        d="M8.3,3.5l2.8,4.8c0.8-0.4,1.7-0.7,2.6-0.7V2C11.8,2.1,10,2.6,8.3,3.5z"
      />
      <path
        fill="#3A5998"
        d="M7.7,13.7c0.1-2,1.2-3.9,2.9-5L7.8,3.9C4.3,6,2.1,9.7,2.1,13.8C2.1,13.8,7.7,13.7,7.7,13.7z"
      />
      <path
        fill="#55ACEE"
        d="M13.7,20.2c-3.2-0.2-5.8-2.7-6-5.9H2C2.2,20.7,7.3,25.8,13.7,26C13.7,26,13.7,20.2,13.7,20.2z"
      />
      <path
        fill="#DFA543"
        d="M19.7,24.5l-2.8-4.8c-0.8,0.4-1.7,0.7-2.6,0.7V26C16.2,25.9,18,25.4,19.7,24.5z"
      />
      <path
        fill="#3A5998"
        d="M20.3,14.3c-0.1,2-1.2,3.9-2.9,5l2.8,4.8c3.5-2.1,5.7-5.8,5.8-9.9L20.3,14.3z"
      />
      <path
        fill="#55ACEE"
        d="M14.3,7.7c3.2,0.2,5.8,2.7,6,5.9H26C25.8,7.2,20.7,2.1,14.3,1.9C14.3,1.9,14.3,7.8,14.3,7.7z"
      />
    </g>

    <g>
      <rect width={28} height={28} rx={1} fill="#F1F2F6" x={32} />
      <path
        fill="#6441A5"
        d="M35.5,19.7l4.9-2.8c-0.4-0.8-0.7-1.7-0.7-2.6H34C34.1,16.2,34.6,18,35.5,19.7z"
      />
      <path
        fill="#3A5998"
        d="M45.7,20.3c-2-0.1-3.9-1.2-5.1-2.9l-4.8,2.8c2.1,3.5,5.8,5.7,9.9,5.8C45.7,26.1,45.7,20.4,45.7,20.3z"
      />
      <path
        fill="#55ACEE"
        d="M52.3,14.3c-0.2,3.2-2.7,5.8-6,6V26c6.4-0.2,11.5-5.3,11.7-11.7H52.3z"
      />
      <path
        fill="#FF6500"
        d="M39.8,13.7c0.2-3.2,2.7-5.8,6-6V2c-6.4,0.2-11.5,5.3-11.7,11.7H39.8z"
      />
      <path
        fill="#DFA543"
        d="M46.3,7.8c3.2,0.2,5.8,2.7,6,6H58C57.8,7.4,52.7,2.3,46.3,2.2V7.8z"
      />
    </g>

    <g>
      <rect width={28} height={28} rx={1} fill="#F1F2F6" x={64} />
      <path
        fill="#DFA543"
        d="M83.8,24.5l-2.7-4.8c-0.8,0.4-1.7,0.7-2.6,0.7V26C80.3,25.9,82.2,25.4,83.8,24.5z"
      />
      <path
        fill="#3A5998"
        d="M84.4,14.3c-0.1,2-1.1,3.9-2.8,5.1l2.8,4.8c3.5-2.1,5.6-5.8,5.7-9.9H84.4z"
      />
      <path
        fill="#07C082"
        d="M77.8,26v-5.6c-3.5-0.1-6.1-3.1-6-6.6c0.1-3.3,2.7-5.9,6-6.1V2C71.3,2,66,7.4,66,14S71.3,26,77.8,26z"
      />
      <path
        fill="#55ACEE"
        d="M78.5,7.8c3.2,0.2,5.8,2.8,5.9,6H90C89.8,7.4,84.8,2.3,78.5,2.2V7.8z"
      />
    </g>
  </g>
);
